import { UtilityText } from "component/text";
import { JudgementCard } from "open-modules/zdf/component/moddashboard/judgementcard";
import { CLICK, DemoSection, INPUT, POPUP, WITHIN } from "system/demo";
import { Datastore } from "util/datastore";
import { defaultPersonaList, personaListToMap } from "util/testpersonas";
import { channelModDashboardDemoData } from "../../../open-modules/zdf/component/channels/__demos__/channel-demo.data";
import { modDashboardDemoData } from "../../../open-modules/zdf/component/moddashboard/__demos__/moddashboard-demo.data";

export function JudgementCardDemo() {

    const modTask_awaiting = modDashboardDemoData.modTaskQueues.thread1.c_t1_awaiting_ai;
    const modTask_approved = modDashboardDemoData.modTaskQueues.thread1.c_t1_approved_auto;
    const modTask_rejected = modDashboardDemoData.modTaskQueues.thread1.c_t1_rejected;

    const myWatchState = {...modDashboardDemoData.watchStates.c_t1_approved_auto, amIViewing:true};
    const otherWatchState = modDashboardDemoData.watchStates.c_t1_approved_auto;

    return (
        <Datastore
            personaPreview={personaListToMap(defaultPersonaList)}
            testState={{
                modulePublic: modDashboardDemoData.modulePublic,
                serverCall: modDashboardDemoData.serverCalls,
            }}
        >
            <DemoSection text="Judgement Card - Approved comment">
                <JudgementCard
                    modTask={modTask_approved}
                    modAuthor={modDashboardDemoData.demoModAuthors[modTask_approved.key]}
                    isSelected={true}
                />
            </DemoSection>
            <DemoSection text="Judgement Card - Rejected comment">
                <JudgementCard
                    modTask={modTask_rejected}
                    modAuthor={modDashboardDemoData.demoModAuthors[modTask_rejected.key]}
                    isSelected={true}
                />
            </DemoSection>
            <DemoSection text="Judgment Card - Awaiting decision">
                <JudgementCard
                    modTask={modTask_awaiting}
                    modAuthor={modDashboardDemoData.demoModAuthors[modTask_awaiting.key]}
                    isSelected={true}
                />
            </DemoSection>
            <DemoSection text="Judgement Card - Different reviewing moderators">
                <UtilityText weight="strong" text="Comment card is selected"/>
                <JudgementCard
                    modTask={modTask_approved}
                    taskWatchState={myWatchState}
                    isSelected={true}
                    modAuthor={modDashboardDemoData.demoModAuthors[modTask_approved.key]}
                />
                <JudgementCard
                    modTask={modTask_approved}
                    taskWatchState={otherWatchState}
                    isSelected={true}
                    modAuthor={modDashboardDemoData.demoModAuthors[modTask_approved.key]}
                />
                <UtilityText weight="strong" text="Comment card is not selected"/>
                <JudgementCard
                    modTask={modTask_approved}
                    taskWatchState={myWatchState}
                    isSelected={false}
                    modAuthor={modDashboardDemoData.demoModAuthors[modTask_approved.key]}
                />
                <JudgementCard
                    modTask={modTask_approved}
                    taskWatchState={otherWatchState}
                    isSelected={false}
                    modAuthor={modDashboardDemoData.demoModAuthors[modTask_approved.key]}
                />
            </DemoSection>
        </Datastore>
    );
}

const modTaskNoWarning = modDashboardDemoData.modTaskQueues.thread1.c_t1_awaiting_ai;
const modTaskOneWarning = modDashboardDemoData.modTaskQueues.thread1.c_t1_approved_first_warning;
const modTaskTwoWarnings = modDashboardDemoData.modTaskQueues.thread1.c_t1_approved_second_warning_authorH;
const modTaskDeleted = modDashboardDemoData.modTaskQueues.thread1.c_t1_awaiting_deleted;
const modTaskApproved = modDashboardDemoData.modTaskQueues.thread1.c_t1_approved_auto;
const modTaskAwaitingDecision = modDashboardDemoData.modTaskQueues.thread1.c_t1_awaiting_ai;

function JudgementCardNoWarningsDemo() {
    return (
        <JudgementCard
            modTask={modTaskNoWarning}
            modAuthor={modDashboardDemoData.demoModAuthors[modTaskNoWarning.key]}
            isSelected={true}
        />
    );
}

function JudgementCardOneWarningDemo() {
    return (
        <JudgementCard
            modTask={modTaskOneWarning}
            modAuthor={modDashboardDemoData.demoModAuthors[modTaskOneWarning.key]}
            isSelected={true}
        />
    );
}

function JudgementCardTwoWarningsDemo() {
    return (
        <JudgementCard
            modTask={modTaskTwoWarnings}
            modAuthor={modDashboardDemoData.demoModAuthors[modTaskTwoWarnings.key]}
            isSelected={true}
        />
    );
}

function JudgementCardWarnBlockDisabledDemo() {
    const modTask_awaiting = modDashboardDemoData.modTaskQueues.thread1.c_t1_awaiting_ai;
    return (
        <JudgementCard
            modTask={modTask_awaiting}
            modAuthor={modDashboardDemoData.demoModAuthors[modTask_awaiting.key]}
            isSelected={true}
            isWarnDisabled={true}
        />
    );
}

function JudgementCardBlockedUserDemo() {
    const modTask_blockedUser = modDashboardDemoData.modTaskQueues.thread1.c_t1_awaiting_blocked;
    return (
        <JudgementCard
            modTask={modTask_blockedUser}
            modAuthor={modDashboardDemoData.demoModAuthors[modTask_blockedUser.key]}
            isSelected={true}
        />
    );
}

function JudgementCardDeletedCommentDemo() {
    return (
        <JudgementCard
            modTask={modTaskDeleted}
            modAuthor={modDashboardDemoData.demoModAuthors[modTaskDeleted.key]}
            isSelected={true}
            isWarnDisabled={true}
        />
    );
}

function JudgementCardApprovedChannelDemo() {
    return (
        <Datastore
            testState={{
                modulePublic: channelModDashboardDemoData.modulePublic,
                serverCall: [channelModDashboardDemoData.serverCalls, modDashboardDemoData.serverCalls],
            }}
        >
            <JudgementCard
                modTask={modTaskApproved}
                modAuthor={modDashboardDemoData.demoModAuthors[modTaskApproved.key]}
                isSelected={true}
            />
        </Datastore>
    );
}

function JudgementCardAwaitingDecisionChannelDemo() {
    return (
        <Datastore
            testState={{
                modulePublic: channelModDashboardDemoData.modulePublic,
                serverCall: [channelModDashboardDemoData.serverCalls, modDashboardDemoData.serverCalls],
            }}
        >
            <JudgementCard
                modTask={modTaskAwaitingDecision}
                modAuthor={modDashboardDemoData.demoModAuthors[modTaskAwaitingDecision.key]}
                isSelected={true}
            />
        </Datastore>
    );
}

export function ModDashboardJudgementCardStorySets() {
    return [
        {
            label: "Judgement Card - User has no warnings",
            serverCall: modDashboardDemoData.serverCalls,
            content: <JudgementCardNoWarningsDemo/>,
            stories: [
                {
                    label: "Approve",
                    actions: [
                        CLICK("Approve")
                    ],
                },
                {
                    label: "Reject",
                    actions: [
                        CLICK("Reject"),
                        CLICK("Reject"),
                    ],
                },
                {
                    label: "Reject and change violations",
                    actions: [
                        CLICK("Reject"),
                        CLICK("Express your ideas with civility"),
                        CLICK("No violent content or calls for harm"),
                        CLICK("Avoid sarcasm and dismissive responses"),
                        CLICK("Reject"),
                    ],
                },
                {
                    label: "Reject and warn",
                    actions: [
                        CLICK("Reject"),
                        CLICK("Express your ideas with civility"),
                        CLICK("Avoid sarcasm and dismissive responses"),
                        WITHIN("judgementCard-" + modTaskNoWarning.key, CLICK("warn-toggle")),
                        CLICK("Reject"),
                    ],
                },
                {
                    label: "Reject and go back",
                    actions: [
                        CLICK("Reject"),
                        CLICK("Other"),
                        CLICK("No violent content or calls for harm"),
                        CLICK("Back to selection"),
                    ],
                },
                {
                    label: "Reject with custom message",
                    actions: [
                        CLICK("Reject"),
                        CLICK("Add explanation to user"),
                        POPUP(INPUT("textfield-explanation-to-user", "Dear user, please avoid doing this.")),
                        POPUP(CLICK("Save")),
                        CLICK("Reject"),
                    ],
                },
                {
                    label: "Reject and edit custom message",
                    actions: [
                        CLICK("Reject"),
                        CLICK("Add explanation to user"),
                        POPUP(INPUT("textfield-explanation-to-user", "Dear user, please avoid doing this.")),
                        POPUP(CLICK("Save")),
                        CLICK("Edit"),
                        POPUP(INPUT("textfield-explanation-to-user", "Dear user, please avoid doing this because it creates a hostile environment for everyone.")),
                        POPUP(CLICK("Save")),
                        CLICK("Reject"),
                    ],
                },
                {
                    label: "Reject and delete custom message",
                    actions: [
                        CLICK("Reject"),
                        CLICK("Add explanation to user"),
                        POPUP(INPUT("textfield-explanation-to-user", "Dear user, please avoid doing this.")),
                        POPUP(CLICK("Save")),
                        CLICK("Delete"),
                        CLICK("Reject"),
                    ],
                },
            ],
        },
        {
            label: "Judgement Card - User has 1 warning",
            serverCall: modDashboardDemoData.serverCalls,
            content: <JudgementCardOneWarningDemo/>,
            stories: [
                {
                    label: "Reject and warn",
                    actions: [
                        WITHIN("judgementCard-" + modTaskOneWarning.key, CLICK("Reject")),
                        WITHIN("judgementCard-" + modTaskOneWarning.key, CLICK("Express your ideas with civility")),
                        WITHIN("judgementCard-" + modTaskOneWarning.key, CLICK("No violent content or calls for harm")),
                        WITHIN("judgementCard-" + modTaskOneWarning.key, CLICK("warn-toggle")),
                        WITHIN("judgementCard-" + modTaskOneWarning.key, CLICK("Reject")),
                    ],
                }
            ],
        },
        {
            label: "Judgement Card - User has 2 warnings",
            serverCall: modDashboardDemoData.serverCalls,
            content: <JudgementCardTwoWarningsDemo/>,
            stories: [
                {
                    label: "Reject and warn",
                    actions: [
                        WITHIN("judgementCard-" + modTaskTwoWarnings.key, CLICK("Reject")),
                        WITHIN("judgementCard-" + modTaskTwoWarnings.key, CLICK("Express your ideas with civility")),
                        WITHIN("judgementCard-" + modTaskTwoWarnings.key, CLICK("No violent content or calls for harm")),
                        WITHIN("judgementCard-" + modTaskTwoWarnings.key, CLICK("warn-toggle")),
                        WITHIN("judgementCard-" + modTaskTwoWarnings.key, CLICK("Reject")),
                    ],
                },
                {
                    label: "Reject, warn and block",
                    actions: [
                        WITHIN("judgementCard-" + modTaskTwoWarnings.key, CLICK("Reject")),
                        WITHIN("judgementCard-" + modTaskTwoWarnings.key, CLICK("Express your ideas with civility")),
                        WITHIN("judgementCard-" + modTaskTwoWarnings.key, CLICK("No violent content or calls for harm")),
                        WITHIN("judgementCard-" + modTaskTwoWarnings.key, CLICK("warn-toggle")),
                        WITHIN("judgementCard-" + modTaskTwoWarnings.key, CLICK("block-toggle")),
                        POPUP(CLICK("Block user")),
                        WITHIN("judgementCard-" + modTaskTwoWarnings.key, CLICK("Reject")),
                    ],
                },
                {
                    label: "Reject and block",
                    actions: [
                        CLICK("Reject"),
                        CLICK("Other"),
                        CLICK("No violent content or calls for harm"),
                        CLICK("block-toggle"),
                        POPUP(CLICK("Block user")),
                        CLICK("Reject"),
                    ],
                },
                {
                    label: "Reject, block, unblock",
                    actions: [
                        CLICK("Reject"),
                        CLICK("Other"),
                        CLICK("No violent content or calls for harm"),
                        CLICK("block-toggle"),
                        POPUP(CLICK("Block user")),
                        CLICK("block-toggle"),
                        POPUP(CLICK("Unblock user")),
                        CLICK("Reject"),
                    ],
                },
                {
                    label: "Reject and open user profile",
                    actions: [
                        CLICK("Reject"),
                        CLICK("Express your ideas with civility"),
                        CLICK("No violent content or calls for harm"),
                        CLICK("Avoid sarcasm and dismissive responses"),
                        CLICK("Show user profile"),
                        CLICK("Reject"),
                    ],
                },
            ],
        },
        {
            label: "Judgement Card - Warnings disabled",
            serverCall: modDashboardDemoData.serverCalls,
            content: <JudgementCardWarnBlockDisabledDemo/>,
            stories: [
                {
                    label: "Reject with warnings disabled",
                    actions: [
                        CLICK("Reject"),
                        CLICK("Other"),
                        CLICK("No violent content or calls for harm"),
                        CLICK("Reject"),
                    ],
                },
            ],
        },
        {
            label: "Judgement Card - Blocked user",
            serverCall: modDashboardDemoData.serverCalls,
            content: <JudgementCardBlockedUserDemo/>,
            stories: [
                {
                    label: "Reject",
                    actions: [
                        CLICK("Reject"),
                        CLICK("Other"),
                        CLICK("Avoid sarcasm and dismissive responses"),
                        CLICK("Reject"),
                    ],
                }
            ],
        },
        {
            label: "Judgement Card - Deleted comment",
            serverCall: modDashboardDemoData.serverCalls,
            content: <JudgementCardDeletedCommentDemo />,
            stories: [
                {
                    label: "Approve",
                    actions: [
                        CLICK("Approve")
                    ],
                },
                {
                    label: "Reject",
                    actions: [
                        CLICK("Reject"),
                        CLICK("Avoid sarcasm and dismissive responses"),
                        CLICK("Reject"),
                    ],
                }
            ],
        },
        {
            label: "Judgement Card - Approved comment with channel",
            content: <JudgementCardApprovedChannelDemo />,
            stories: [
                {
                    label: "Reply",
                    actions: [
                        CLICK("Reply"),
                        POPUP(INPUT("textfield-editorial-comment", "Thanks for sharing!")),
                        POPUP(CLICK("Post")),
                    ],
                },
                {
                    label: "Reply and cancel",
                    actions: [
                        CLICK("Reply"),
                        POPUP(INPUT("textfield-editorial-comment", "Thanks for sharing!")),
                        POPUP(CLICK("Cancel")),
                    ],
                },
            ],
        },
        {
            label: "Judgement Card - Comment awaiting decision with channel",
            content: <JudgementCardAwaitingDecisionChannelDemo />,
            stories: [
                {
                    label: "Approve and reply",
                    actions: [
                        CLICK("Approve"),
                        CLICK("Reply"),
                        POPUP(INPUT("textfield-editorial-comment", "Thanks for sharing!")),
                        POPUP(CLICK("Post")),
                    ],
                },
                {
                    label: "Approve, reply, cancel",
                    actions: [
                        CLICK("Approve"),
                        CLICK("Reply"),
                        POPUP(INPUT("textfield-editorial-comment", "Thanks for sharing!")),
                        POPUP(CLICK("Cancel")),
                        CLICK("No thanks"),
                    ],
                },
            ],
        },
    ];
}